module.exports = __webpack_public_path__ + "img/baignoire.8f06226.svg";